enum NylasStatus {
  CONNECTED = "connected",
  INVALID = "invalid",
  RUNNING = "running",
  STOPPED = "stopped",
  SYNC_ERROR = "sync_error",
}

export default NylasStatus;
